import React, { useState, useRef } from 'react'
import {
  useWallet,
  useLocalLabels,
  useConfigState,
  WalletDTOStatusEnum,
  useIsAuthenticated,
} from '@sentecacommerce-theme/lib'
import { Loader, RadioInput } from '../../../Common'
import styled from 'styled-components'
import { RequestWallet, ActivateWallet } from './Components'
import { ProfileLabels } from '../../profile.props'
import { setHeight, getHeight } from '../../utils/heightPredictor'

export const Wallet = () => {
  const config = useConfigState()
  const { data, isLoading } = useWallet(config.wallets.hippoWallet)
  const [form, setForm] = useState('')
  const { wallet } = useLocalLabels<ProfileLabels>()
  const containerRef = useRef<any>()
  const closeForm = () => setForm('')
  const formsMap = {
    request: <RequestWallet closeForm={closeForm} />,
    activate: <ActivateWallet closeForm={closeForm} />,
  }
  const { isAuthenticated } = useIsAuthenticated()

  if (data) {
    if (containerRef?.current?.children) {
      setHeight({ page: 'wallet', height: containerRef?.current?.offsetHeight })
    }
  }

  if (!isAuthenticated) {
    setHeight({ page: 'wallet', height: 52 })
  }

  const labels = wallet?.labels?.cardInfo

  const toggleWalletForms = (value: string) => {
    setForm(value)
  }

  if (isLoading) {
    const height = getHeight('wallet')

    return (
      <LoaderContainer height={height ? height + 'px' : '67.8rem'}>
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      </LoaderContainer>
    )
  }

  if (!data && !isLoading) {
    return !form ? (
      <div>
        <RadioInput
          label={wallet?.labels?.activateWallet?.callToAction}
          value="activate"
          onChange={toggleWalletForms}
        />
        <RadioInput
          label={wallet?.labels?.requestWallet?.callToAction}
          value="request"
          onChange={toggleWalletForms}
        />
      </div>
    ) : (
      formsMap[form]
    )
  }

  return (
    <Wrapper ref={containerRef}>
      <CardContainer>
        <Card src={labels.image} alt="Hippoland" />
      </CardContainer>
      <Details>
        {data?.status === WalletDTOStatusEnum?.Active && labels.titleActive}
        {data?.status === WalletDTOStatusEnum?.Requested &&
          labels.titleRequested}

        <li>{labels.discount1}</li>

        <li>{labels.discount2}</li>
      </Details>
    </Wrapper>
  )
}

const LoaderContainer = styled.div<{ height: string }>`
  height: ${(props) => props.height};
`

const LoaderWrapper = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-center',
})`
  /* height: 12rem; */
`

const Wrapper = styled.div.attrs({
  className: 'd-flex',
})`
  @media (max-width: ${({ theme }) => theme.breakpoints.md.max}) {
    flex-direction: column;
  }
`
const CardContainer = styled.div`
  border: 0.1rem solid ${({ theme }) => theme.palette.silverTree};
  border-radius: 0.3rem;
  max-width: 36rem;
  box-shadow: -2px 2px 4px 0 #aaa;
`
const Card = styled.img`
  width: 100%;
  height: 100%;
`
const Details = styled.ul.attrs({
  className: 'p-5',
})`
  font-size: 1.7rem;
  line-height: 3rem;
  list-style-type: circle;
  & li {
    line-height: 2rem;
    margin: 2rem;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md.max}) {
    padding: 2rem 0 !important;
  }
`
